export default __webpack_public_path__ + "static/media/go-maxi.28be4a06.jpg";